import React, { Component } from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

function AlertSnack(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default class AlertAlgo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            openSnack: false,
            message: '',
            typeAlert: 'error',
            duration: 6000
        }
    }

    handleCloseSnack = () => {
        this.setState({
            openSnack: false,
            message: ''
        });
    }

    showMessageError = (msg, duration = 6000) => {
        this.setState({
            openSnack: true,
            message: msg,
            typeAlert: 'error',
            duration: duration
        });
    }

    showMessageWarning = (msg, duration = 6000) => {
        this.setState({
            openSnack: true,
            message: msg,
            typeAlert: 'warning',
            duration: duration
        });
    }

    showMessageSuccess = (msg, duration = 6000) => {
        this.setState({
            openSnack: true,
            message: msg,
            typeAlert: 'success',
            duration: duration
        });
    }

    render() {
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={this.state.openSnack}
                autoHideDuration={this.state.duration}
                onClose={this.handleCloseSnack}
                severity="success"
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={this.handleCloseSnack}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            >
                <AlertSnack onClose={this.handleCloseSnack} severity={this.state.typeAlert} style={{ textAlign: "left" }}>
                    <div>
                        {!Array.isArray(this.state.message) && this.state.message.split('\n').map((line, idx) => (
                            <React.Fragment key={idx}>
                                {line}<br />
                            </React.Fragment>
                        ))}
                        {Array.isArray(this.state.message) && this.state.message.map((line, idx) => (
                            <React.Fragment key={idx}>
                                {line}<br />
                            </React.Fragment>
                        ))}
                    </div>
                </AlertSnack>
            </Snackbar>
        );
    }
}